/*
  LH | Scroll to the first unfilled TeeInBlue field (Leon, 29.10.2026).
  Why: a tap on "In den Warenkorb" with a required TeeInBlue choice still open marks the fields red, but TeeInBlue
  only scrolls when the field is close to the button. With a long form (4 people on the Herzensmenschen mug) desktop
  did not scroll at all and mobile stopped below the first red field, so the customer saw no reason and thought the
  shop was broken. Here: after the tap, if the first red field is not on screen, scroll so its heading sits under the
  sticky header. Text, select and picture fields alike (.tee-field--invalid is TeeInBlue's own marker).
*/
(function () {
  if (window.__lhTeeInvalidScroll) return;
  window.__lhTeeInvalidScroll = true;

  function firstInvalid() {
    var list = document.querySelectorAll('.tee-field--invalid');
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent) return list[i];
    return null;
  }
  function headerHeight() {
    var h = document.querySelector('sticky-header, .section-header');
    return h ? Math.min(h.getBoundingClientRect().height, 140) : 0;
  }
  function check() {
    var f = firstInvalid();
    if (!f) return false;
    var head = headerHeight();
    var r = f.getBoundingClientRect();
    // already readable: the heading is below the header and the field starts in the upper part of the screen
    if (r.top >= head + 4 && r.top <= window.innerHeight * 0.6) return true;
    var top = Math.max(0, r.top + window.scrollY - head - 16);
    window.scrollTo({ top: top, behavior: 'smooth' });
    // a browser that does not animate (reduced motion, background tab) still ends at the field
    setTimeout(function () { if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top: top, behavior: 'auto' }); }, 1200);
    return true;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.tee-btn--atc, .product-form__submit');
    if (!btn) return;
    // TeeInBlue validates asynchronously and runs its own scroll first. Red marks of fields filled since the last tap
    // can stay for a moment on a slow phone (QA 29.10.2026: it scrolled to the filled #1 instead of #4), and TeeInBlue
    // may scroll elsewhere after us: keep looking for 3 s and bring the first red field back on screen.
    var tries = [400, 900, 1600, 2400, 3200];
    (function next(i) {
      if (i >= tries.length) return;
      setTimeout(function () {
        // check() only scrolls when the first red field is off screen, so a later TeeInBlue scroll is corrected too
        check();
        next(i + 1);
      }, i ? tries[i] - tries[i - 1] : tries[0]);
    })(0);
  }, true);
})();
